import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core'
import { MatMenuTrigger } from '@angular/material/menu'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { ComissaoModel, InstituicaoModel } from '@shared/models/backend'
import { CnpjPipe } from '@widgets/pipes/cnpj/cnpj.pipe'
import { CpfPipe } from '@widgets/pipes/cpf/cpf.pipe'

@Component({
  selector: 'app-comissao-table',
  templateUrl: './comissao-table.component.html',
  styleUrls: ['./comissao-table.component.scss'],
  providers: [CpfPipe, CnpjPipe],
})
export class ComissaoTableComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger
  @Input() instituicao: InstituicaoModel

  filterChange: EventEmitter<string> = new EventEmitter()
  dataSource = new MatTableDataSource<ComissaoModel>()
  displayedColumns = []

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.displayedColumns = ['tipoComissao', 'contato', 'telefone', 'email', 'actions']

    this.dataSource.data = this.instituicao.comissoes
  }

  onClickEditarComissao(comissao: ComissaoModel) {
    let instituicaoId = this.instituicao.id

    this.router.navigateByUrl(`instituicao/${instituicaoId}/comissao/editar/${comissao.id}`)
  }
}
